import React from 'react';
import './App.css';
import OidcCallback from "./pages/OidcCallback";
import OidcSilentCallback from "./pages/OidcSilentCallback";
import '../src/common/flexboxgrid.css';
import {
  BrowserRouter as Router,
  Route, Switch
} from "react-router-dom";
import ActivationPage from './ActivationPage';
import PhonebookViewMoreAuthGate from "./pages/PhonebookViewMoreAuthGate";

function App() {
  return (
    <Router>
      <Switch>
        {/* IDCS redirect callback */}
        <Route exact path="/callback" component={OidcCallback} />
        <Route exact path="/silent-callback" component={OidcSilentCallback} />
        <Route exact path="/phonebook/view-more" component={PhonebookViewMoreAuthGate} />
        <Route exact path="/" component={ActivationPage} />
      </Switch>
    </Router>
  );
}

export default App;
